// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#bfcbd9","headerHight":"60px","menuBg":"#304156","sideTreeWidth":"250px","subMenuActiveText":"#409fff","subMenuBg":"#1f2d3d","subMenuHover":"#7c93a9"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 54